import React from 'react';

import { Control } from 'react-hook-form';
import { LbInput } from '@infoods/lifebase-ui';

import { InputBox, LbAutocomplete } from '../../../../shared/components/form-components';
import { states } from '../../../../shared/constants/states';
import { validateZipCode } from '../../../../shared/utils/reactHookFormUtils';
import { CombinedCustomerInfo } from '../../../interfaces/Customer';

type AddressDataFromProps = {
  control: Control<CombinedCustomerInfo>;
};

const AddressDataFrom = ({ control }: AddressDataFromProps) => {
  const generalInputProps = {
    control,
    size: 'small',
    variant: 'standard',
  } as const;

  const privateInfoProps = { InputProps: { className: 'private-info' } };

  return (
    <InputBox title="Address">
      <LbInput
        {...generalInputProps}
        {...privateInfoProps}
        name="customer.address1"
        label="Address"
        rules={{ required: 'Address is required' }}
      />
      <LbInput
        {...generalInputProps}
        {...privateInfoProps}
        name="customer.city"
        label="City"
        rules={{ required: 'City is required' }}
      />
      <LbAutocomplete
        {...generalInputProps}
        {...privateInfoProps}
        name="customer.state"
        label="State"
        options={states}
        rules={{ required: 'State is required', deps: ['customer.zipCode'] }}
      />
      <LbInput
        {...generalInputProps}
        {...privateInfoProps}
        name="customer.zipCode"
        label="Zip Code"
        rules={{
          required: 'Zip Code is required',
          validate: async (zipCode, { customer }) =>
            validateZipCode(zipCode, customer.state),
        }}
      />
    </InputBox>
  );
};

export { AddressDataFrom };
